import {
    IconArrowDown,
    IconChevronDown,
    IconArrowLeft,
    IconArrowRight,
    IconFacebook,
    IconGithub,
    IconInstagram,
    IconLinkedin,
    IconMastodon,
    IconMenu,
    IconPinterest,
    IconTelegram,
    IconTiktok,
    IconVimeo,
    IconWhatsapp,
    IconX,
    IconXMark,
    IconYoutube,
} from '@/components/icons';

/**
 * Registry for UiIcon: maps a stored icon key (kebab-case) to its component.
 * Social keys mirror the Studio picker (studio/constants/iconOptions.ts →
 * SOCIAL_ICON_OPTIONS) and use simple-icons fills; the rest are UI glyphs used
 * statically in the app. An unknown key renders nothing (see UiIcon).
 */
export const ICONS = {
    // UI / navigational icons (used statically in the app)
    'arrow-down': IconArrowDown,
    'chevron-down': IconChevronDown,
    'arrow-left': IconArrowLeft,
    'arrow-right': IconArrowRight,
    menu: IconMenu,
    'x-mark': IconXMark,

    // Social platforms (SOCIAL_ICON_OPTIONS) — simple-icons fill set
    instagram: IconInstagram,
    linkedin: IconLinkedin,
    x: IconX,
    facebook: IconFacebook,
    github: IconGithub,
    youtube: IconYoutube,
    vimeo: IconVimeo,
    tiktok: IconTiktok,
    pinterest: IconPinterest,
    whatsapp: IconWhatsapp,
    telegram: IconTelegram,
    mastodon: IconMastodon,
};

export type IconName = keyof typeof ICONS;

export function isIconName(value: unknown): value is IconName {
    return typeof value === 'string' && value in ICONS;
}
